import { render, staticRenderFns } from "./complaint.vue?vue&type=template&id=e7eb175e&"
import script from "./complaint.vue?vue&type=script&lang=js&"
export * from "./complaint.vue?vue&type=script&lang=js&"
import style0 from "./complaint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports